import useApiClient, { useRequestInit } from './apiClient';
import { ServiceBinding } from '@core/lib/serviceBindings';
import { GetWeatherResponse } from '@wisionmonorepo/api-client-v1/src/responses';

export const useWeatherApi = (
  baseUrl: string,
  serviceBinding: ServiceBinding | null = null,
  sessionCookie: string | null = null
) => {
  const apiClient = useApiClient(serviceBinding?.fetch.bind(serviceBinding));
  const getRequestInit = useRequestInit(serviceBinding?.fetch, sessionCookie);

  const getWeatherFromLocation = async (lat: string, long: string, lang = 'en', days = 5) =>
    await apiClient<GetWeatherResponse[]>(
      `${baseUrl}/api/v1/weather/getWeather?lat=${lat}&lon=${long}&days=${days}&lang=${lang}`,
      getRequestInit({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
    );

  return {
    getWeatherFromLocation
  };
};
